module.exports = __webpack_public_path__ + "akne_7_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/akne_7_after.jpg
// module id = 927
// module chunks = 0